import { i18nKeys } from 'translationTypes'
import i18n from '../i18n'

export default {
  emailNull: () => i18n.t(i18nKeys.validators__emailNull),
  emailInvalid: () => i18n.t(i18nKeys.validators__emailInvalid),
  phoneNumberNull: () => i18n.t(i18nKeys.validators__phoneNumberNull),
  phoneNumberInvalid: () => i18n.t(i18nKeys.validators__phoneNumberInvalid),
  optionalPhoneNumberInvalid: () =>
    i18n.t(i18nKeys.validators__optionalPhoneNumberInvalid),
  zipCodeNull: () => i18n.t(i18nKeys.validators__zipCodeNull),
  zipCodeInvalid: () => i18n.t(i18nKeys.validators__zipCodeInvalid),
  legalTextUnchecked: () => i18n.t(i18nKeys.validators__legalTextUnchecked),
  firstNameNull: () => i18n.t(i18nKeys.validators__firstNameNull),
  firstNameInvalidLength: () =>
    i18n.t(i18nKeys.validators__firstNameInvalidLength),
  firstNameInvalidCharacters: () =>
    i18n.t(i18nKeys.validators__firstNameInvalidCharacters),
  middleNameNull: () => i18n.t(i18nKeys.validators__middleNameNull),
  middleNameInvalidCharacters: () =>
    i18n.t(i18nKeys.validators__middleNameInvalidCharacters),
  lastNameNull: () => i18n.t(i18nKeys.validators__lastNameNull),
  lastNameInvalidLength: () =>
    i18n.t(i18nKeys.validators__lastNameInvalidLength),
  lastNameInvalidCharacters: () =>
    i18n.t(i18nKeys.validators__lastNameInvalidCharacters),
  passwordNull: () => i18n.t(i18nKeys.validators__passwordNull),
  passwordInvalidLength: () =>
    i18n.t(i18nKeys.validators__passwordInvalidLength),
  passwordConfirmNoMatch: () =>
    i18n.t(i18nKeys.validators__passwordConfirmNoMatch),
  licenseNumberNull: () => i18n.t(i18nKeys.validators__licenseNumberNull),
  licenseStateNull: () => i18n.t(i18nKeys.validators__licenseStateNull),
  vehicleTypeNull: () => i18n.t(i18nKeys.validators__vehicleTypeNull),
  insuranceCheckNull: () => i18n.t(i18nKeys.validators__insuranceCheckNull),
  ssnInvalid: () => i18n.t(i18nKeys.validators__ssnInvalid),
  ssnConfirmNoMatch: () => i18n.t(i18nKeys.validators__ssnConfirmNoMatch),
  abnInvalid: () => i18n.t(i18nKeys.validators__abnInvalid),
  birthdayInvalid: () => i18n.t(i18nKeys.validators__birthdayInvalid),
  birthdayInvalidDate: () => i18n.t(i18nKeys.validators__birthdayInvalidDate),
  birthdayInvalidMinDate: () =>
    i18n.t(i18nKeys.validators__birthdayInvalidMinDate),
  redCardLastFourInvalidLength: () =>
    i18n.t(i18nKeys.validators__redCardLastFourInvalidLength),
  redCardLastFourNull: () => i18n.t(i18nKeys.validators__redCardLastFourNull),
  redCardDelightNumberInvalidLength: () =>
    i18n.t(i18nKeys.validators__redCardDelightNumberInvalidLength),
  redCardDelightNumberNull: () =>
    i18n.t(i18nKeys.validators__redCardDelightNumberNull),
  makeError: () => i18n.t(i18nKeys.needsVehicleInfo__form__makeError),
  modelError: () => i18n.t(i18nKeys.needsVehicleInfo__form__modelError),
  colorError: () => i18n.t(i18nKeys.needsVehicleInfo__form__colorError),
  backgroundCheckCitizenship: () =>
    i18n.t(i18nKeys.backgroundCheck__jpnCitizenshipTitle),
  countryError: () => i18n.t(i18nKeys.address__form__countryError),
  postCodeError: () => i18n.t(i18nKeys.address__form__postCodeError),
  postCodeInvalid: () => i18n.t(i18nKeys.address__form__postCodeInvalid),
  addressError: () => i18n.t(i18nKeys.address__form__addressError),
  stateError: () => i18n.t(i18nKeys.address__form__stateError),
  cityError: () => i18n.t(i18nKeys.address__form__cityError),
  zipCodeError: () => i18n.t(i18nKeys.address__form__zipCodeError),
  typeError: () => i18n.t(i18nKeys.alias__form__typeError),
  firstNameError: () => i18n.t(i18nKeys.alias__form__firstNameError),
  middleNameError: () => i18n.t(i18nKeys.alias__form__middleNameError),
  lastNameError: () => i18n.t(i18nKeys.alias__form__lastNameError),
}
